<script>
import {ref, watch} from "vue";

export default {
    props: {
        /** v-model: ordered array of selected values */
        value: {type: Array, default: () => []},
        /** all items — array of objects OR plain strings */
        items: {type: Array, default: () => []},
        itemText: {type: String, default: 'name'},
        itemValue: {type: String, default: 'id'},
        leftTitle: {type: String, default: 'Disponible'},
        rightTitle: {type: String, default: 'Choisie'},
        height: {type: Number, default: 320},
        readonly: {type: Boolean, default: false},
    },
    setup(props, {emit}) {
        const dialog = ref(false);
        
        const selectedItems = ref([]);
        
        watch(selectedItems, () => {
            emit('input', selectedItems.value);
        });
        
        watch(() => props.value, () => {
            selectedItems.value = props.value;
        }, {immediate: true});
        
        return {
            dialog,
            selectedItems,
        };
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="1200"
            scrollable
        >
            <v-card>
                <v-card-text>
                    <v-container fluid>
                        <w-dual-list-selector
                            v-model="selectedItems"
                            :items="items"
                            :itemText="itemText"
                            :itemValue="itemValue"
                            :leftTitle="leftTitle"
                            :rightTitle="rightTitle"
                            :height="height"
                            :readonly="readonly"
                        />
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <w-enum-select
            v-model="selectedItems"
            :items="items"
            :item-text="itemText"
            readonly
            multiple
            append-outer-icon="mdi-cursor-default-click"
            @append-outer-click="dialog= true"
            @click="dialog = true"
        />
        
        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>